
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { parse } from 'date-fns';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import PublicPortfolioWorkHistoryForm from '~/components/partials/public-portfolio/PublicPortfolioWorkHistory/PublicPortfolioWorkHistoryForm.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import type { Portfolio } from '~/types/portfolio';
import TrashIcon from '~/assets/svg/trash-opaque.vue.svg';
import type { FormState } from '~/types/common';

export default Vue.extend({
  name: 'PublicPortfolioEditWorkHistoryModal',
  components: { PublicPortfolioWorkHistoryForm, PublicPortfolioModal, BravadoButtonV3, TrashIcon },
  data(): { formState: FormState } {
    return {
      formState: 'idle',
    };
  },
  computed: {
    ...mapState('portfolio', ['workHistories']),
    workHistory(): Partial<Portfolio.Workhistory> {
      return (
        (this.workHistories as Portfolio.Workhistory[]).find(wh => String(wh.id) === this.$route.query['wh-id']) || {}
      );
    },
    isSaveButtonDisabled(): boolean {
      if (this.formState === 'error') {
        // @ts-ignore
        return this.$refs.wsForm.$v.$invalid;
      } else {
        return this.formState !== 'idle';
      }
    },
  },
  methods: {
    ...mapActions('portfolio', ['updateWorkHistory', 'removeWorkHistory']),
    async onSubmit(): Promise<void> {
      this.formState = 'idle';

      // @ts-ignore
      if (this.$refs.wsForm.$v.$invalid) {
        this.formState = 'error';
      } else if (this.workHistory) {
        this.formState = 'submitting';

        // @ts-ignore
        const { startMonth, endMonth, startYear, endYear, isCurrentWorkplace, title, company } = this.$refs.wsForm.form;

        try {
          const baseDate = new Date();
          const payload = {
            id: this.workHistory.id,
            title,
            public: true,
            current_workplace: isCurrentWorkplace,
            company_id: company.id,
            start_date: parse(`${startMonth}/${startYear}`, 'MMMM/yyyy', baseDate).toString(),
            end_date: '',
          };

          if (!isCurrentWorkplace) payload.end_date = parse(`${endMonth}/${endYear}`, 'MMMM/yyyy', baseDate).toString();

          await this.updateWorkHistory(payload);

          this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_EDIT_WORK_HISTORY_MODAL);
          this.$notice.success('Work history updated');
        } catch (e) {
          // @ts-ignore
          if (e?.response?.data?.errors) {
            // @ts-ignore
            for (const error of e?.response?.data?.errors) this.$notice.error(error);
          } else {
            this.$notice.error('Could not update work history. Try again later');
          }
          this.$sentryUtils.error(e);
        } finally {
          this.formState = 'idle';
        }
      }
    },
    async onJobDelete(): Promise<void> {
      if (confirm('Are you sure?') && this.workHistory) {
        try {
          await this.removeWorkHistory({ id: this.workHistory.id });
          this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_EDIT_WORK_HISTORY_MODAL);
          this.$notice.success('Work history removed');
        } catch (e) {
          this.$notice.error('Could not remove work history.');
          this.$sentryUtils.error(e);
        }
      }
    },
  },
});
